import React, { useState } from 'react';
import axios from 'axios';
import { API } from '../../App';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '@/components/ui/dialog';
import { KeyRound } from 'lucide-react';
import { toast } from 'sonner';
import { apiError } from '../../lib/apiError';

const TeacherLoginDialog = ({ teacher, onDone }) => {
  const [open, setOpen] = useState(false);
  const [password, setPassword] = useState('');
  const [saving, setSaving] = useState(false);
  const hasLogin = !!teacher.login_user_id;

  const submit = async () => {
    setSaving(true);
    try {
      await axios.post(`${API}/teachers/${teacher.id}/login`, { password });
      toast.success(hasLogin ? 'Password reset' : `Login created for ${teacher.email}`);
      setPassword('');
      setOpen(false);
      onDone();
    } catch (e) {
      toast.error(apiError(e, 'Could not set up login'));
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
      <Button variant="outline" size="sm" className="w-full rounded-full" onClick={() => setOpen(true)} data-testid={`teacher-login-button-${teacher.id}`}>
        <KeyRound className="w-4 h-4 mr-2" />{hasLogin ? 'Reset Portal Password' : 'Create Portal Login'}
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent data-testid="teacher-login-dialog">
          <DialogHeader>
            <DialogTitle>{hasLogin ? 'Reset teacher password' : 'Create teacher login'}</DialogTitle>
            <DialogDescription>
              {teacher.name} will sign in with <span className="font-medium">{teacher.email}</span> to manage availability,
              pricing and sessions. They can change the password later.
            </DialogDescription>
          </DialogHeader>
          <div className="space-y-1.5">
            <Label htmlFor="teacher-password">Password (min 6 characters)</Label>
            <Input id="teacher-password" type="text" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="teacher-login-password-input" />
          </div>
          <DialogFooter>
            <Button variant="outline" className="rounded-full" onClick={() => setOpen(false)}>Cancel</Button>
            <Button onClick={submit} disabled={saving || password.length < 6} className="bg-violet-600 hover:bg-violet-700 text-white rounded-full" data-testid="teacher-login-submit-button">
              {saving ? 'Saving...' : hasLogin ? 'Reset Password' : 'Create Login'}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default TeacherLoginDialog;
